module.exports = __webpack_public_path__ + "img/giftcard_desktop.cedf84d5.svg";